import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen flex items-end overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://images.pexels.com/photos/11291684/pexels-photo-11291684.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1080&w=1920"
          alt="Luxury car in dark garage"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pb-24 md:pb-32 pt-40 w-full">
        <div className="max-w-4xl reveal">
          <div className="flex items-center gap-3 mb-8">
            <span className="w-12 h-px bg-red-500" />
            <span className="text-xs tracking-[0.3em] uppercase text-red-500 font-bold">
              Since 2026 · Sheboygan, WI
            </span>
          </div>

          <h1
            data-testid="hero-heading"
            className="font-display text-5xl sm:text-6xl lg:text-8xl leading-[0.9] tracking-tighter uppercase"
          >
            Every detail.
            <br />
            <span className="text-zinc-600">Every</span>{" "}
            <span className="text-red-500 italic font-serif tracking-normal lowercase">
              gleam
            </span>
            .
          </h1>

          <p className="mt-8 text-lg md:text-xl text-zinc-400 max-w-xl leading-relaxed">
            Premium ceramic coatings, paint correction, and interior detailing
            by obsessive craftsmen. Your vehicle deserves nothing less than
            apex.
          </p>

          <div className="mt-12 flex flex-wrap gap-4">
            <a
              href="#packages"
              data-testid="hero-cta-packages"
              className="group inline-flex items-center gap-3 bg-red-500 hover:bg-red-400 text-white px-8 py-5 font-bold text-xs tracking-[0.2em] uppercase transition-all duration-300"
            >
              View Packages
              <ArrowRight
                size={16}
                className="group-hover:translate-x-1 transition-transform"
              />
            </a>
            <a
              href="#services"
              data-testid="hero-cta-services"
              className="inline-flex items-center gap-3 border border-zinc-700 hover:border-red-500 text-white px-8 py-5 font-bold text-xs tracking-[0.2em] uppercase transition-all duration-300 bg-transparent"
            >
              <Sparkles size={16} /> Our Services
            </a>
          </div>
        </div>
      </div>

      {/* Scroll hint */}
      <div className="absolute bottom-6 right-6 md:right-12 z-10 hidden md:flex items-center gap-4 rotate-90 origin-bottom-right">
        <span className="text-xs tracking-[0.3em] uppercase text-zinc-500">
          Scroll
        </span>
        <span className="w-12 h-px bg-zinc-600" />
      </div>
    </section>
  );
}
